import React from "react";

import BaseSvg, { BaseSvgProps } from "../../BaseSvg";

const EvocationSvg: React.FunctionComponent<BaseSvgProps> = ({
  className = "",
  fillColor,
  secondaryFillColor,
}) => {
  return (
    <BaseSvg className={className} viewBox="0 0 60 60">
      <path
        fill={fillColor}
        d="M55.6 29q-3.7-.6-7.3-.8a2 2 0 0 1-1.7-1.2L45.3 25a2 2 0 0 1 0-2.5q.8-.9 1.3-1.9c.4-.6-.2-1.4-.9-1.1L42.4 21c-.5.3-1.5.4-2.2.1q-.9-.7-.3-2.2 1-2.6 1.6-5.4c.2-.8-.9-1.2-1.3-.6l-3.3 5.6a2 2 0 0 1-2 1l-1.6-.2a2 2 0 0 1-1.6-1.9q-.2-5-.8-9.2c-.1-1-1.6-1-1.7 0q-.6 4.2-.8 9.2a2 2 0 0 1-1.7 1.9l-1.5.2a2 2 0 0 1-2-1Q21.8 15.7 20 13c-.4-.6-1.5-.2-1.3.6q.6 2.9 1.6 5.4.6 1.6-.3 2.2h-.1q-1 .4-1.8 0-2-1.5-4.3-2.5a.8.8 0 0 0-1 1q1 1.4 2 2.7a2 2 0 0 1 .1 2.4q-.9 1.1-1.3 2.3a2 2 0 0 1-1.7 1.2l-7.3.7c-1 .1-1 1.6 0 1.7l7.2.7q1.1 0 1.7 1.2L14 34a2 2 0 0 1-.3 2.4l-.3.2-2.9 3q-.3.3 0 .8t1 .4l4.7-2.8a2 2 0 0 1 2 0q1.3.7 1 2.1t-.6 2.8q0 .3.2.6c1 1 2-1.3 2.7-2l.4-.6a2 2 0 0 1 2-.7l2.6.5a2 2 0 0 1 1.7 1.8q.1 4.5 1 9c.1.8 1.4.8 1.5 0q.8-4.5 1-9a2 2 0 0 1 1.6-1.8l2.6-.5a2 2 0 0 1 2 .8l2 2.5.7.2c1.4-.2.3-2.4.2-3.3v-.3a2 2 0 0 1 .8-2.1 2 2 0 0 1 2 0q2.4 1.6 4.9 2.8c.7.3 1.4-.6.9-1.2q-1.4-1.7-3.2-3.2A2 2 0 0 1 46 34l.7-1.3a2 2 0 0 1 1.7-1.2q3.6-.2 7.2-.8c.9-.2.8-1.5 0-1.6m-27.4 7.3q-.1.7-.8.7-3.3-.3-6.2-1.6a10 10 0 0 1-3.8-2.6c-.3-.5 0-1.2.6-1.2h9.5q.6.1.7.8zm0-9q0 .7-.7.8h-9.6q-1-.2-.6-1.1 1.1-1.5 3.8-2.9a21 21 0 0 1 6.4-1.7q.7 0 .8.7zm14.4 5.5q-1.6 1.7-3.8 2.6-2.9 1.3-6.2 1.6a1 1 0 0 1-.8-.7v-3.9q.1-.6.8-.7H42c.6 0 1 .7.5 1.1m-.5-4.7h-9.5a1 1 0 0 1-.7-.8v-4.2q0-.7.7-.7 3.4.3 6.3 1.7 2.3 1 3.8 2.8c.4.5 0 1.2-.6 1.2"
      />
    </BaseSvg>
  );
};

export default EvocationSvg;
